import { render } from "./StripeSuccess.vue?vue&type=template&id=057571c1&scoped=true"
import script from "./StripeSuccess.vue?vue&type=script&lang=js"
export * from "./StripeSuccess.vue?vue&type=script&lang=js"

import "./StripeSuccess.vue?vue&type=style&index=0&id=057571c1&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057571c1"]])

export default __exports__